import { constUndefined, flow } from 'fp-ts/function';
import { array, option } from 'fp-ts';
import { createAction } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { TravelAgencyContract } from '@mews-commander/data-access';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createEntitiesReducer, createBaseEntitySelectors, createEntitySelectorByCompanyId } from './utils';

export const NAME = 'travelAgencyContracts';

const TRAVEL_AGENCY_CONTRACTS_LOADED = prefix('TRAVEL_AGENCY_CONTRACTS_LOADED');

export const setTravelAgencyContracts = (travelAgencyContracts: Array<TravelAgencyContract>) =>
    createAction(TRAVEL_AGENCY_CONTRACTS_LOADED, { entities: travelAgencyContracts });

export const travelAgencyContractsReducer = createEntitiesReducer({
    FETCH_SUCCESS: TRAVEL_AGENCY_CONTRACTS_LOADED,
});

export const [
    getTravelAgencyContracts,
    getTravelAgencyContractsByIds,
    getTravelAgencyContractsByOwnerId,
    getTravelAgencyContract,
] = createBaseEntitySelectors<ApplicationState, TravelAgencyContract, typeof NAME>(parentSelector, NAME);

const getTravelAgencyContractsByCompanyId = createEntitySelectorByCompanyId(getTravelAgencyContracts);

export const getTravelAgencyContractId = flow(
    getTravelAgencyContractsByCompanyId,
    array.head,
    option.match(constUndefined, ({ id }) => id)
);
